import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Slot, Slottable } from '@radix-ui/react-slot';
import { cx } from '../../../internal/cx.js';
function BackGlyph() {
    return (_jsx("svg", { "aria-hidden": true, focusable: false, width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", stroke: "currentColor", strokeWidth: 1.75, strokeLinecap: "round", strokeLinejoin: "round", children: _jsx("path", { d: "M10 4 6 8l4 4" }) }));
}
/**
 * A link to the parent page, with a leading back arrow. Works with any
 * router through `asChild`.
 */
export const BackLink = forwardRef(function BackLink({ variant = 'subtle', asChild = false, className, children, ...rest }, ref) {
    const Comp = asChild ? Slot : 'a';
    return (_jsxs(Comp, { ref: ref, ...rest, "data-variant": variant, className: cx('mn-back-link', className), children: [_jsx("span", { className: "mn-back-link__icon", children: _jsx(BackGlyph, {}) }), _jsx(Slottable, { children: children })] }));
});
//# sourceMappingURL=back-link.js.map